/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-11-30 13:58:17
 * @Description:
 */

import "./NoImageMask.scss";
import { FTFullDragUpload, FTSampleList } from "src/components";
import { FTCanvasStore, FTImageStore } from "src/store";
import { FTFotorFeatureDB, hanldelFTUserProfile, utils } from "src/utils";
import { IconMagicWand, UploadIcon } from "src/assets";
import { urls } from "src/constant";
import React, { useEffect, useState } from "react";
import {
  actionClickUp,
  actionFeatureClickUp,
  actionImportImageResult
} from "src/analyze/actions";
import { autorun, set } from "mobx";
import { useLanguage, useQueryRoute } from "src/hooks";

import { ExampleEffectItem } from "src/store/types";
import loadable from "@loadable/component";
import { message } from "antd";
import qs from "qs";
import styles from "./NoImageMask.module.scss";
import SelectImagesComp from "src/components/SelectImage";
import EventBusInstances, { EventName } from "src/constant/eventBus";

const FTMoreLink = loadable(
  () =>
    import(
      /* webpackChunkName: "more-link" */
      "src/components/FTMoreLink/FTMoreLink"
    ),
  { ssr: false }
);
export default function NoImageMask() {
  const [exampleList, setExampleList] = React.useState<ExampleEffectItem[]>([]);
  useQueryRoute();
  const uploadImage = async (e: any) => {
    e.preventDefault && e.preventDefault();
    e.stopPropagation && e.stopPropagation();
    actionFeatureClickUp("get_started");
    FTImageStore.uploadImage("upload_image");
  };

  const handleFullSelectImage = async (blobs: File[]) => {
    const [firstBlob] = blobs;
    actionFeatureClickUp("get_started");
    FTImageStore.uploadImage("drop_upload", firstBlob);
  };
  useEffect(() => {
    const dispose = autorun(() => {
      const { examplesList } = FTImageStore;
      setExampleList(examplesList);
    });
    return () => {
      dispose();
    };
  }, []);

  const dropImage = async (e: any) => {
    if (e.dataTransfer && e.dataTransfer.files.length) {
      actionImportImageResult("drop_upload", true);
      hanldelFTUserProfile();
      FTCanvasStore.changeLoading(true);
      let file = e.dataTransfer.files[0];
      const checkResult = await utils.checkImage(file);
      if (!checkResult.result) {
        message.error(t(checkResult.message));
        FTCanvasStore.changeLoading(false);
        return;
      }

      let {
        canvas: imageElement,
        acturalSize,
        currentSize
      } = await utils.getImageFromFile(file);
      FTImageStore.setCurrentImageElement(
        imageElement,
        currentSize,
        acturalSize
      );
      FTImageStore.setCurrentImage(file);
      let effect =
        FTImageStore.effectClassifyMap.length &&
        FTImageStore.effectClassifyMap[0].list[0];
      if (effect) {
        FTImageStore.getGoartEffect(effect);
        actionClickUp(
          utils.toFixed(effect.id as unknown as number, 0),
          effect.name
        );
      }
      FTCanvasStore.changeLoading(false);
    } else {
      actionImportImageResult("drop_upload", false);
    }
  };

  const handleSampleEffect = (effect: ExampleEffectItem) => {
    try {
      FTImageStore.effectClassifyMap.forEach((items) => {
        items.list.forEach((sonItem) => {
          if (sonItem.id === effect.templateId) {
            EventBusInstances.emit(EventName.GO_SCROLL, items.id);
            FTImageStore.startSampleItem(effect);
            throw new Error("");
          }
        });
      });
    } catch {}
  };
  const { t } = useLanguage();

  return (
    <div
      className='noimage'
      onClick={(e) => {
        uploadImage(e);
      }}>
      <div className='noimage_bg'>
        <img src={urls.assetsUrl + "/img/background/bg-1.jpg"} alt='' />
        <div className='noimage_bg_mask'></div>
      </div>
      <FTFullDragUpload onDropFiles={(files) => handleFullSelectImage(files)} />

      <div className='noimage_content'>
        <div className='noimage_content_header'>
          <div
            className='noimage_content_header_content'
            dangerouslySetInnerHTML={{
              __html: t("noimage_title")
            }}></div>
          <div className='noimage_content_header_icon'>
            <IconMagicWand />
          </div>
        </div>
        <div className='noimage_content_drag_panel'>
          <div
            onClick={(el) => {
              el.stopPropagation();
            }}
            className={styles["upload-btn"]}>
            <div
              onClick={(e) => {
                uploadImage(e);
              }}
              className={styles["upload-left"]}>
              <UploadIcon width={24} />
              {t("goart_open_image")}
            </div>
            <SelectImagesComp
              onChange={(file) => {
                actionFeatureClickUp("get_started");
                FTImageStore.uploadImage("upload_image", file);
              }}
              className={styles["upload-right"]}
            />
          </div>
          {/* <FTButton
            type='primary'
            className='noimage_btn'
            onClick={(e) => uploadImage(e)}>
            <IconOpenImage style={{ marginRight: withUnit(8) }} />
            <span> {t("goart_open_image")} </span>
          </FTButton> */}
        </div>
        <div className='noimage_content_sample_wrapper'>
          <FTSampleList
            list={exampleList}
            onEffect={handleSampleEffect}></FTSampleList>
        </div>
      </div>
      <div className='noimage_right_bottom'>
        <FTMoreLink />
      </div>
    </div>
  );
}
